import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import localStorageService from '@/shared/services/localStorageService';
import get from 'lodash.get';
import translationEN from './locales/en.json';
import translationDE from './locales/de.json';

const userInfo = JSON.parse(localStorageService.getuserInfo());

// the translations
const resources = {
  en: {
    translation: translationEN
  },
  de: {
    translation: translationDE
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: get(userInfo, 'language') || 'en',

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
